module.exports = __webpack_public_path__ + "static/media/upgradepayroll.42885abb.svg";